<template>
	<div class="site-footer">
		<div class="footer-bg">
			<el-image class="footer-img" :src="require('@/static/CodeBuddyAssets/31120_1115/41.png')"></el-image>
		</div>
		<div class="footer-inner">
			<!-- 友情链接 -->
			<div class="friend-links">
				<span class="link-label">{{ $t('footer.friendLinks.label') }}：</span>
				<span class="link-item">{{ $t('footer.friendLinks.baidu') }}</span>
				<span class="link-item">{{ $t('footer.friendLinks.fengchi') }}</span>
				<span class="link-item">{{ $t('footer.friendLinks.douyin') }}</span>
			</div>
			<!-- 分割线 -->
			<div class="divider"></div>
			<!-- 内容区 -->
			<div class="footer-content">
				<!-- 资源 -->
				<div class="footer-col">
					<p class="col-title">{{ $t('footer.cols.resource.title') }}</p>
					<p class="col-item">{{ $t('footer.cols.resource.latestNews') }}</p>
					<p class="col-item">{{ $t('footer.cols.resource.faq') }}</p>
				</div>
				<!-- 快递 -->
				<div class="footer-col">
					<p class="col-title">{{ $t('footer.cols.express.title') }}</p>
					<p class="col-item">{{ $t('footer.cols.express.prohibitedItems') }}</p>
					<p class="col-item">{{ $t('footer.cols.express.serviceTerms') }}</p>
				</div>
				<!-- 解决方案 -->
				<div class="footer-col">
					<p class="col-title">{{ $t('footer.cols.solutions.title') }}</p>
					<p class="col-item">{{ $t('footer.cols.solutions.myOrder') }}</p>
					<p class="col-item">{{ $t('footer.cols.solutions.shippingTutorial') }}</p>
					<p class="col-item">{{ $t('footer.cols.solutions.orderManagement') }}</p>
					<p class="col-item">{{ $t('footer.cols.solutions.logisticsQuery') }}</p>
				</div>
				<!-- 关于 -->
				<div class="footer-col">
					<p class="col-title">{{ $t('footer.cols.about.title') }}</p>
					<p class="col-item">{{ $t('footer.cols.about.express100') }}</p>
					<p class="col-item" @click="openContactDialog">{{ $t('footer.cols.about.aboutUs') }}</p>
					<p class="col-item">{{ $t('footer.cols.about.shentong') }}</p>
					<p class="col-item">{{ $t('footer.cols.about.yuantong') }}</p>
					<p class="col-item">{{ $t('footer.cols.about.zhongtong') }}</p>
				</div>
				<!-- 关注我们 -->
				<div class="footer-col contact-col">
					<p class="col-title">{{ $t('footer.contact.title') }}</p>
					<p class="col-desc">{{ $t('footer.contact.desc') }}</p>
					<el-image class="qr-code" :src="require('@/static/ma.jpg')"></el-image>
					<!-- <p class="hotline">{{ $t('footer.contact.hotline') }}：020-8585885</p> -->
					<div class="contact-btn" @click="openContactDialog">{{ $t('footer.contact.btnText') }}</div>
				</div>
			</div>
			<!-- 底部分割线 -->
			<div class="divider"></div>
			<!-- 版权信息 -->
			<div class="copyright">
				<span @click="gowlink1">Copyright 2026广州利国际供应链有限公司粤</span>
				<span class="cp-white" @click="gowlink2"> ICP备2026063366号-1XML</span>
			</div>
		</div>

		<!-- ====== 联系我们弹窗 ====== -->
		<el-dialog
			:visible.sync="contactDialogVisible"
			width="5.84rem"
			custom-class="contact-dialog"
			:show-close="false"
			:close-on-click-modal="true"
			:append-to-body="true"
			:modal-append-to-body="true">
			
			<!-- 弹窗内容 -->
			<div class="contact-modal">
				<!-- 头部区域（标题 + 关闭按钮） -->
				<div class="modal-header-bg">
					<el-image
						class="modal-close-btn"
						style="opacity: 0;"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')">
					</el-image>
					<h3 class="modal-title">{{ $t('footer.contact.btnText') }}</h3>
					<el-image 
						class="modal-close-btn"
						:src="require('@/static/CodeBuddyAssets/32719_3658/1.svg')"
						@click="closeContactDialog">
					</el-image>
				</div>

				<!-- 公司信息区域 -->
				<div class="company-info">
					<h4 class="company-name-cn">{{pzMsg.companyName}}</h4>
					<p class="company-name-en">{{pzMsg.companyNameEn}}</p>
					
					<!-- 地址 -->
					<div class="info-row">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/2.svg')">
						</el-image>
						<span class="info-text">{{pzMsg.companyAddress}}</span>
					</div>
					
					<!-- 国内电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/3.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText1') }}：{{pzMsg.chinaPhoneNumber}}</span>
					</div>
					
					<!-- 国际电话 -->
					<div class="info-row info-row--phone">
						<el-image 
							class="info-icon"
							:src="require('@/static/CodeBuddyAssets/32719_3658/4.svg')">
						</el-image>
						<span class="info-text">{{ $t('footer.contact.btnText2') }}：{{pzMsg.foreignPhoneNumber}}</span>
					</div>
				</div>

				<!-- 二维码区域 -->
				<div class="qrcode-section">
					<!-- 微信二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.wechatQrCode"
							:preview-src-list="[pzMsg.wechatQrCode]">
						</el-image>
						<p class="qrcode-label">{{ $t('footer.contact.btnText3') }}</p>
						<p class="qrcode-id">{{pzMsg.wechat}}</p>
					</div>
					
					<!-- WhatsApp二维码 -->
					<div class="qrcode-item">
						<el-image 
							class="qrcode-img"
							:src="pzMsg.whatsappQrCode"
							:preview-src-list="[pzMsg.whatsappQrCode]">
						</el-image>
						<p class="qrcode-label">WhatsAPP</p>
						<p class="qrcode-id">{{pzMsg.whatsapp}}</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	configbase
} from "/src/api/api.js"
export default {
	name: 'SiteFooter',
	data() {
		return {
			contactDialogVisible: false,
			pzMsg:'',
		}
	},
	mounted() {
		this.configbase()
	},
	methods: {
		// 配置信息
		async configbase(){
			var res;
			res = await configbase({});
			if(res.code==200){
				this.pzMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		gowlink1(){
			var url = 'http://www.binli-logistics.com/'
			window.open(url, '_blank', 'noopener,noreferrer');
		},
		gowlink2(){
			var url = 'https://beian.miit.gov.cn/'
			window.open(url, '_blank', 'noopener,noreferrer');
		},
		openContactDialog() {
			this.contactDialogVisible = true;
		},
		closeContactDialog() {
			this.contactDialogVisible = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.site-footer {
	position: relative;
	width: 100%;
	height: 4.46rem;
}
.footer-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #22293C;
	.footer-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}
.footer-inner {
	position: relative;
	z-index: 1;
	padding: 0 2.87rem;
}
.friend-links {
	padding-top: 0.24rem;
	display: flex;
	align-items: center;
	.link-label {
		color: #999;
		font-size: 0.12rem;
	}
	.link-item {
		color: #fff;
		font-size: 0.12rem;
		margin-right: 0.20rem;
		cursor: pointer;
		transition: opacity 0.3s;
		&:hover {
			opacity: 0.8;
		}
	}
}
.divider {
	height: 0.01rem;
	background: rgba(230, 232, 237, 0.30);
	margin: 0.16rem 0;
}
.footer-content {
	display: flex;
	padding-top: 0.32rem;
	padding-bottom: 0.12rem;
}
.footer-col {
	margin-right: 1.08rem;
	.col-title {
		color: #fff;
		font-size: 0.16rem;
		font-weight: 500;
		margin-bottom: 0.16rem;
	}
	.col-item {
		color: #fff;
		font-size: 0.13rem;
		font-weight: 400;
		line-height: 0.26rem;
		cursor: pointer;
		transition: opacity 0.3s;
		&:hover {
			opacity: 0.7;
		}
	}
	.col-desc {
		color: #9AA2B1;
		font-size: 0.13rem;
		font-weight: 500;
	}
}
.contact-col {
	margin-left: auto;
	margin-right: 0;
	.qr-code {
		width: 0.80rem;
		height: 0.80rem;
		margin: 0.12rem 0;
	}
	.hotline {
		color: #fff;
		font-size: 0.13rem;
		font-weight: 500;
		margin-bottom: 0.06rem;
	}
	.contact-btn {
		width: 1.96rem;
		height: 0.36rem;
		background: #0096FF;
		text-align: center;
		line-height: 0.36rem;
		color: #fff;
		font-size: 0.14rem;
		font-weight: 500;
		cursor: pointer;
		transition: background 0.3s;
		margin-top: 0.12rem;
		&:hover {
			background: #33ABFF;
		}
	}
}
.copyright {
	padding-top: 0.06rem;
	font-size: 0.12rem;
	cursor: pointer;
	color: #999;
	.cp-white {
		color: #fff;
	}
}

/* ============================================================
   联系我们弹窗样式 (基于 Figma 设计 - 无定位属性)
   ============================================================ */
.contact-modal {
	// width: 572px;
	background: white;
	border-radius: 10px;
	box-sizing: border-box;
	padding: 3px;
}

/* 头部区域（渐变背景 + 标题 + 关闭按钮） */
.modal-header-bg {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 66px;
	background: linear-gradient(180deg, #E4F4FF 0%, white 100%);
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
	padding: 0 16px;
}

/* 标题 */
.modal-title {
	font-size: 22px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #2F3541;
	margin: 0;
	white-space: nowrap;
}

/* 关闭按钮 */
.modal-close-btn {
	width: 20px;
	height: 20px;
	cursor: pointer;
	flex-shrink: 0;
	transition: opacity 0.3s;
	&:hover {
		opacity: 0.7;
	}
}

/* 公司信息区域 */
.company-info {
	padding: 20px 60px;
}

.company-name-cn {
	font-size: 24px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 500;
	color: #333333;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 10px;
}

.company-name-en {
	font-size: 14px;
	font-family: 'PingFang SC', sans-serif;
	font-weight: 400;
	color: #CBCBCB;
	white-space: nowrap;
	text-align: center;
	margin-bottom: 26px;
}

/* 信息行（地址、电话） */
.info-row {
	display: flex;
	align-items: center;
	height: 22px;
	margin-bottom: 24px;
	&:last-child{
		margin-bottom: 10px;
	}
	
	.info-icon {
		width: 18px;
		height: 18px;
		flex-shrink: 0;
	}
	
	.info-text {
		margin-left: 8px;
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #7C8388;
		white-space: nowrap;
	}
}

.info-row--phone {
	width: auto;
}

/* 二维码区域 */
.qrcode-section {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	padding: 30px 0 20px;
	padding-top: 10px;
}

.qrcode-item {
	width: 158px;
	text-align: center;
	margin: 0 21px;
	
	.qrcode-img {
		width: 158px;
		height: 158px;
		cursor: pointer;
		display: block;
		border: 1px solid #eee;
		margin-bottom: 10px;
	}
	
	.qrcode-label {
		font-size: 16px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #333333;
		margin: 8px 0 4px;
	}
	
	.qrcode-id {
		font-size: 18px;
		font-family: 'PingFang SC', sans-serif;
		font-weight: 400;
		color: #0096FF;
		margin: 0;
	}
}
</style>

<!-- 全局样式：覆盖 el-dialog 默认样式 -->
<style lang="scss">
.contact-dialog {
	border-radius: 10px !important;
	overflow: visible;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
	
	.el-dialog__header {
		display: none;
		padding: 0;
		margin: 0;
	}
	
	.el-dialog__body {
		padding: 6px;
	}
	
	.el-dialog__footer {
		display: none;
		padding: 0;
		margin: 0;
	}
}
</style>
